module.exports = __webpack_public_path__ + "static/media/bg.e001f432.jpg";